import { flattenEditableProps } from './flattenEditableProps';

export const normalizeEditableInfo = (editableInfo) => {
    return editableInfo.map((item) => ({
        ...item,
        editableProps: flattenEditableProps(item.editableProps)
    }));
};
